export enum ELeasePacketUrls {
  LEASE_PACKET = 'lease-packet',
  ADDENDUM = 'addendum',
}
